module.exports = __webpack_public_path__ + "img/CS26Q-中_08.5087f9e8.jpg";